// extracted by mini-css-extract-plugin
export default {"contentDiv":"HallLayout_contentDiv__cP+AF","title":"HallLayout_title__2175p","picture":"HallLayout_picture__isJ4U"};